import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";

const Screen = lazy(() => import("../../views/company-invitation"));

export const Route = createFileRoute("/(open)/company-invitation")({
  component: RouteComponent,
  staticData: {
    routeKey: "company-invitation",
    access: "open",
    layout: "blank",
    container: "default",
    requiredRoles: [],
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
